module.exports = __webpack_public_path__ + "img/av021.b1538588.png";